// Code used from https://github.com/awesomejerry/react-native-qrcode-svg
// react-native-qrcode-svg is licensed under The MIT License (MIT)
var transformMatrixIntoPath = function (matrix, size) {
    var cellSize = size / matrix.length;
    var path = '';
    if (!matrix || !Array.isArray(matrix)) {
        return {};
    }
    matrix.forEach(function (row, i) {
        var needDraw = false;
        row.forEach(function (column, j) {
            if (column) {
                if (!needDraw) {
                    path += "M".concat(cellSize * j, " ").concat(cellSize / 2 + cellSize * i, " ");
                    needDraw = true;
                }
                if (needDraw && j === matrix.length - 1) {
                    path += "L".concat(cellSize * (j + 1), " ").concat(cellSize / 2 + cellSize * i, " ");
                }
            }
            else {
                if (needDraw) {
                    path += "L".concat(cellSize * j, " ").concat(cellSize / 2 + cellSize * i, " ");
                    needDraw = false;
                }
            }
        });
    });
    return {
        cellSize: cellSize,
        path: path
    };
};
export default transformMatrixIntoPath;
